import { queryOptions, useQuery } from "@tanstack/react-query"
import axios from "axios"

type ShopifyLocation = {
  id: string
  name: string
  fulfillsOnlineOrders: boolean
  isFulfillmentService: boolean
  isActive: boolean
  address?: { city?: string | null; country?: string | null } | null
}

const shopifyLocationsQuery = () =>
  queryOptions({
    queryKey: ["shopify", "locations"],
    queryFn: async () => {
      const { data } = await axios.get<{ data: ShopifyLocation[] }>(
        "/integrations/shopify/locations",
      )
      return data.data
    },
  })

export function useShopifyLocationsQuery(enabled: boolean) {
  return useQuery({ ...shopifyLocationsQuery(), enabled })
}
